import { render, staticRenderFns } from "./explore-categories.vue?vue&type=template&id=4efc6d2e&"
import script from "./explore-categories.vue?vue&type=script&lang=js&"
export * from "./explore-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports